<template>
    <div class="contact-container">
        <template v-if="data">
            <div class="info user-info">
                <!-- <a :href="data.github">
                    <Icon type="xiaomao" />
                    <span class="info-text">misutaaa</span>
                </a> -->
                <div>
                    <Icon type="xiaomao" />
                    <span class="info-text">misutaaa</span>
                </div>
            </div>
            <div class="info email-info">
                <!-- <a href="mailto:3076005011@qq.com">
                    <Icon type="youxiang" />
                    <span class="info-text">{{ data.mail }}</span>
                </a> -->
                <div>
                    <Icon type="youxiang" />
                    <span class="info-text">969247291@qq.com</span>
                </div>
            </div>
            <div class="info qq-info">
                <!-- <a href="tencent://message/?Menu=yes&uin=3076005011&Service=300&sigT=45a1e5847943b64c6ff3990f8a9e644d2b31356cb0b4ac6b24663a3c8dd0f8aa12a595b1714f9d45"
                    class="a-qq-info">
                    <Icon type="11qq" />
                    <span class="info-text">{{ data.qq }}</span>
                </a> -->
                <div class="a-qq-info">
                    <Icon type="11qq" />
                    <span class="info-text">969247291</span>
                </div>
                <!-- <div class="hover qq-hover">
                    <img class="hover-img" :src="data.qqQrCode" alt="">
                </div> -->
            </div>
            <div class="info weixin-info">
                <!-- <a href="" class="a-weixin-info">
                    <Icon type="weixin" />
                    <span class="info-text">{{ data.weixin }}</span>
                </a> -->
                <div href="" class="a-weixin-info">
                    <Icon type="weixin" />
                    <span class="info-text">az969247291</span>
                </div>
                <!-- <div class="hover weixin-hover">
                    <img class="hover-img" :src="data.weixinQrCode" alt="">
                </div> -->
            </div>
        </template>
    </div>
</template>

<script>
import Icon from '../Icon';
import { mapState } from 'vuex';
export default {
    components: {
        Icon
    },
    computed: mapState('setting', ['data']),
    created() {
        this.$store.dispatch('setting/getData')
    }
}
</script>

<style lang="less">
.icon-container {
    display: inline-block;
}

.contact-container {
    width: 100%;
    flex-direction: column;
    display: flex;
    align-items: center;
    position: relative;

    // overflow: hidden;
    .hover {
        position: absolute;
        top: -95px;
        width: 100px;
        height: 100px;
        // background: red;
        transform: scaleY(0);
        transform-origin: center bottom;
        transition: 0.3s;
        background: #fff;

        &::after {
            position: absolute;
            left: 45px;
            // transform: translateX(-50%);
            bottom: -5px;
            transform: rotate(45deg);
            transform-origin: center center;
            content: "";
            width: 10px;
            height: 10px;
            background: #fff;
        }

        .hover-img {
            position: absolute;
            top: 12px;
            left: 12px;
            width: 75%;
            height: 75%;
            object-fit: cover;

        }
    }

    // .user-info:hover{
    //         background: #666;
    // }
    // .email-info:hover{
    //         background: #666;
    // }
    .qq-info:hover {
        cursor: pointer;

        // background: #666;
        .qq-hover {
            transform: scaleY(1);
        }
    }

    .weixin-info:hover {
        cursor: pointer;

        // background: #666;
        .weixin-hover {
            transform: scaleY(1);
        }
    }

    .info {
        box-sizing: border-box;
        width: 100%;
        height: 50px;
        line-height: 50px;
        padding-left: 26px;
        position: relative;

        &:hover {
            .iconfont {
                color: #6b9eee
            }

            .info-text {
                color: #6b9eee;
            }
        }

        .iconfont {
            color: #999;
            line-height: 40px;
            font-size: 20px;
        }

        .info-text {
            position: absolute;
            top: 0;
            color: #999;
            font-size: 14px;
            padding-left: 8px;
        }
    }



}
</style>